import React from 'react';
import { Fab, IconButton, Paper, Divider } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import { fillThemeColor, Scrollbar } from './Base';
import { createIcon, Util, runtime } from '../common';
import { Card, CardTitle } from "reactstrap";



function getTheme(theme, titleLine) {
    switch (theme) {
        case "flat": return { radius: "0", headerClassName: '', iconClassName: "text-grey c-icon-s3 mr-2", titleClassName: "text-dark c-text-s2", containerPadding: 'p-0', elevation: 0, bodyClassName: '' }
        case "card": return { radius: "0.375rem", headerClassName: '', iconClassName: "text-white c-icon-s4 mr-2", titleClassName: "text-white c-text-s2", containerPadding: 'p-3', elevation: 4, bodyClassName: '' }
        case "panel": return { radius: "0.1rem", headerClassName: `${titleLine ? 'c-lb' : ''} py-3 px-4`, iconClassName: "text-grey c-icon-s3 mr-2", titleClassName: "text-dark c-text-s2", containerPadding: 'p-0', elevation: 4, bodyClassName: 'p-3' }
    }
}


const Portal = ({ theme, color, icon, title, tools, children, className, elevation, radius, iconClassName, containerPadding, headerClassName, titleClassName, bodyClassName, header, full, height,width, face, flat, scrollable, narrow, titleLine }) => {
    if (flat) theme = "flat";
    let arg = getTheme(theme, titleLine);
    if (color) arg['color'] = color;
    if (!Util.empty(elevation)) arg['elevation'] = elevation;
    if (!Util.empty(radius)) arg['radius'] = radius;
    if (iconClassName) arg['iconClassName'] = arg['iconClassName'] + ' ' + iconClassName;
    if (containerPadding) arg["containerPadding"] = containerPadding;
    if (bodyClassName) arg['bodyClassName'] = arg['bodyClassName'] + ' ' + bodyClassName;

    let faceClassName = face && !flat ? "shadow-xs c-l" : "";

    let props = fillThemeColor({ style: { borderRadius: arg.radius }, className: `c-portal ${theme == 'flat' || flat ? 'c-flat' : ''} ${narrow ? 'c-portal-narrow' : ''} ${arg.containerPadding} ${faceClassName} mb-0 d-flex flex-column ${full ? 'c-flex-1' : ''} ${className}` }, color, true);
    icon = createIcon(icon, arg.iconClassName);

    props.style.height = height;
    props.style.width = width;

    const renderHeader = () => {

        if (header == "pc" && !runtime.pc) return;
        if (header == "mo" && !runtime.mobile) return;

        return icon || title || tools ?
            <div className={`d-flex flex-row align-items-center justify-content-between ${arg.headerClassName} ${headerClassName}`}>
                <div className="d-flex flex-row align-items-center">
                    {icon ? icon : null}
                    <h3 className={`m-auto ${arg.titleClassName} ${titleClassName}`}>{title}</h3>
                </div>
                <div className="c-protal-tools">
                    {tools}
                </div>
            </div>
            : null;
    }

    const tryScrollable = (content) => {
        return (
            scrollable ? (
                <Scrollbar>
                    {content}
                </Scrollbar>
            ) : content
        );
    }


    //   return (
    //     <div className={`${animated?'animated slideInUpTiny animation-duration-3':''} c-container  d-flex flex-column ${full?'h-100':''} ${className}`} style={style} {...props}>
    //       {tryScrollable(children)}
    //     </div>
    //   )

    return (
        <Paper {...props} elevation={arg.elevation}>
            {renderHeader()}
            <div className={`jr-card-hd-content ${arg.bodyClassName} ${full ? 'd-flex flex-column c-flex-1' : ''} `}>
                {tryScrollable(children)}
            </div>
        </Paper>
    );
};

Portal.defaultProps = {
    header: '',
    theme: "panel", //panel card
    className: '',
    headerClassName: '',
    full: false,
    face: true,
    narrow: false,
    scrollable: false,
    titleLine: true
}

Portal.detailProps = {
    narrow: true,
    titleLine: false,
    titleClassName:runtime.mobile ? "c-text-s3" :  "c-text-s4",
    headerClassName: "c-p-0",
    bodyClassName: "c-p-0",
    className: runtime.mobile ?  "c-py-2d5 c-px-3 my-2" : "c-py-4d5 c-px-5 my-2"
}

Portal.detailFlatProps = {
    ...Portal.detailProps,
    flat:true,
    className: runtime.mobile ? "c-py-0 c-px-1 my-2" :"c-py-0 c-px-5 my-2"
}

Portal.detailModalProps = {
    flat: true,
    titleLine: false,
    titleClassName: "c-text-s3",
    headerClassName: "c-p-0",
    bodyClassName: "c-p-0",
    className: runtime.pc ? "c-py-3 c-px-4 c-my-2" :"c-p-0"
}

Portal.detailWideModalProps = {
    ...Portal.detailModalProps,
    className: runtime.pc ? "c-py-3 c-px-0 c-my-2" :"c-p-0"
}

export default Portal;

export class PortalTitle extends React.Component {

    constructor(props) {
        super(props);
    }

    renderDescription() {
        let { description } = this.props;
        return (
            description ? (
                <div className="d-flex c-text-s2 m-text-dark-50">
                    {Util.type(description) === "string" ? <p className="mb-0">{description}</p> : description}
                </div>
            ) : null
        );
    }

    render() {
        let { icon,iconClassName,title, className, tools, line, titleClassName,narrow,lineClassName } = this.props;
        return (
            <div className={`d-flex flex-column ${narrow?'c-portal-narrow':''} ${className}`}>
                <div className={`d-flex flex-row align-items-center justify-content-between`}>
                    <div className={`d-flex align-items-center justify-content-start`}>
                        {createIcon(icon,`text-dark mr-2 ${iconClassName}`)}
                        <h3 className={`text-dark mb-0 ${titleClassName}`}>{title}</h3>
                    </div>
                    {tools ? <div className={`d-flex align-items-center `}>
                        {tools}
                    </div> : null}
                </div>
                {this.renderDescription()}
                {line ? <Divider className={lineClassName} /> : null}
            </div>
        )
    }
}

PortalTitle.defaultProps = {
    className: "mb-4",
    titleClassName: "c-text-s2 c-text-sm-s4",
    line: false,
    lineClassName:"mt-2"
}

PortalTitle.gapClassName = "c-mt-1 c-mb-3";

export class Setting extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { onClick } = this.props;
        return (
            <IconButton className={`icon-btn p-1`} onClick={() => { if (onClick) onClick(); }}>
                <SettingsIcon className="text-grey c-icon-s2 c-icon-sm-s3" />
            </IconButton>
        )
    }
}
